export enum EcoSettingsBlockTypeEnum {
  SLIDER = 'SLIDER',
  CATEGORY_LIST = 'CATEGORY_LIST',
  BANNER = 'BANNER',
  PRODUCTS = 'PRODUCTS',
  NEW_ITEM = 'NEW_ITEM',
  SALE = 'SALE',
  BESTSELLER = 'BESTSELLER',
}
